import React from 'react';
import { useOrderTypeContext } from '../../Contexts/OrderTypeContext';
import CustomerService from '../../Services/CustomerService';
import ButtonPrimary from './ButtonPrimary';
import { TbCircleFilled, TbX } from 'react-icons/tb';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import { Formik, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import 'react-phone-input-2/lib/style.css'
import { useStoreHook } from '../../Hooks/StoreHook';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ERROR_CUSTOMER_NOT_FOUND } from '../../Utils/Constants/Login';
import Button from './Button';
import { useLoginContext } from '../../Contexts/LoginContext';
import { useCartContext } from '../../Contexts/CartContext';

const getValidationSchema = (t: any) =>
    Yup.object().shape({
        email: Yup.string()
            .min(2, t("form.validation.invalid_min_characters", {quantity: 2}))
            .email(t('form.validation.invalid_email'))
            .required(t('form.validation.required'))
});

const FormForgotPassword = () => {

    const { t } = useTranslation();
    const validationSchema = getValidationSchema(t);
    const { orderType } = useOrderTypeContext();
    const { setShowCart, setReturnToCheckout } = useCartContext();
    const { setShowForgotPassword, setShowLoginBasic } = useLoginContext();
    const { setMainLoading, setMainLoadingIcon, setMainLoadingIconSuccess, setMainLoadingTitle, setMainLoadingMessage, setMainLoadingCloseButton, setMainLoadingIconError } = useLayoutContext();
    const { getLinkToHome } = useStoreHook();
    const navigate = useNavigate();

    const initialData = {
        email: '',
    }

    const handlePasswordRecover = async (data: any) => {
        const payload = {
            email: data.email,
        }
        try {
            setMainLoading(true);
            setMainLoadingTitle(t('Enviando email'));
            setMainLoadingMessage(t('layout.loading_main.default_message'));

            const customerService = new CustomerService(orderType);
            const response = await customerService.passwordRecover(payload);

            if (response.status === 204) {

                setShowCart(false);
                setReturnToCheckout(false);

                setMainLoadingIcon(false);
                setMainLoadingIconSuccess(true);
                setMainLoadingTitle(t('login.forgot_password.message_success'));
                setMainLoadingMessage('');
                setMainLoadingCloseButton(true);
                navigate(getLinkToHome());

                setShowLoginBasic(false);
                setShowForgotPassword(false);
            }

        } catch (error: any) {
            setMainLoading(true);
            setMainLoadingIcon(false);
            setMainLoadingIconError(true);
            setMainLoading(true);
            setMainLoadingCloseButton(true);
            if (error?.response?.data?.error === ERROR_CUSTOMER_NOT_FOUND) {
                setMainLoadingTitle(t('login.forgot_password.errors.customer_not_found_title'));
                setMainLoadingMessage('');
            } else {
                setMainLoadingTitle(t('errors.default_title'));
                setMainLoadingMessage(t('errors.default_message'));
            }
        }
    }

    const isFieldRequired = (schema: any, fieldName: string) => {
        const field = schema.describe().fields[fieldName];
        return field.tests.some((test: any) => test.name === 'required');
    };

    return (
        <>
            <Formik
                initialValues={initialData}
                validationSchema={validationSchema}
                onSubmit={(data) => {
                    handlePasswordRecover(data);
                }}
                >
                {({ setFieldValue, values }) => (
                    <Form className="flex flex-col gap-4 justify-between ">

                        <div className='h-full grid gap-3 p-4 bg-gray-50 rounded-xl'>

                            <div className='flex flex-col gap-3'>
                                <div className='w-full text-left'>
                                    <span className='font-semibold text-shopfood-title'>
                                        {t('login.form.email.label')}
                                        {isFieldRequired(validationSchema, 'email') && (<sup className="text-shopfood-error inline-flex ml-0.5"> <TbCircleFilled size={7} /></sup>)}
                                    </span>
                                    <input
                                        id="email"
                                        type='email'
                                        name="email"
                                        value={values.email}
                                        onChange={(e) => setFieldValue('email', e.target.value)}
                                        autoComplete='on'
                                        autoFocus
                                        className="relative block w-full rounded border-0 p-2 ring-1 ring-gray-300 placeholder:text-gray-300 placeholder:font-normal font-bold focus:ring-2 focus:ring-gray-500 transition-all ease-in-out duration-200"
                                    />
                                    <ErrorMessage name="email" component="div" className='text-xs text-shopfood-error pt-1' />
                                </div>

                            </div>
                        </div>

                        <div className='flex gap-2 p-2 pt-0 flex-wrap'>
                            <ButtonPrimary type={'submit'} className='gap-1 w-full flex-1 md:w-auto text-nowrap' onClick={() => {}}>
                                {t('login.forgot_password.button_submit.label')}
                            </ButtonPrimary>

                            <Button
                                rounded
                                onClick={() => setShowForgotPassword(false)}
                            >
                                <TbX size={20} className='shrink-0' />
                            </Button>
                        </div>

                    </Form>
                )}
            </Formik>
        </>
    )
}

export default FormForgotPassword;
